import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Rip } from 'src/app/models';
import { faTimes, faSave } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'app-rip-dialog',
  templateUrl: './rip-dialog.component.html',
  styles: [],
})
export class RipDialogComponent implements OnInit {
  public form: FormGroup;
  public faTimes = faTimes;
  public faSave = faSave;
  constructor(
    public dialogRef: MatDialogRef<RipDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { rip: Rip; title: string; rips: Rip[] },
  ) {}

  ngOnInit() {
    const formFields: { [key: string]: any } = {
      number: [this.data.rip.number, Validators.required],
    };
    if (this.data.rip.number) {
      formFields.createdBy = [this.data.rip.createdBy];
      formFields.createdTime = [this.data.rip.createdTime];
    }
    this.form = this.fb.group(formFields);
  }
  cancel() {
    this.dialogRef.close(null);
  }

  save() {
    this.dialogRef.close(this.form.value);
  }
}
